(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-product-seo-content"] && !Shopify.designMode) return;
  try {
    
// Custom scripts (if necessary)

  } catch(e) { console.error(e); }
})();
})();
